import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';

const useStyles = makeStyles((theme) => ({
    formControl: {
      marginRight: theme.spacing(1),
      backgroundColor: '#ffffff',
      borderRadius: '5px',
      color: '#4D4D4D',
      letterSpacing: '2px',
      '&:hover': {
        background: "#e6e6e6",
     },
     whiteSpace: 'nowrap',
     textTransform: 'uppercase'
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    typography: {
        padding: theme.spacing(2),
      },
    root : {
      color: '#4D4D4D',
    },
    popoverPaper: {
      backgroundColor: '#ffffff',
      width: 'auto'
    },
    link: {
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        /* identical to box height, or 143% */
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        letterSpacing: '0.25px',
        padding: '7px',
        cursor: 'pointer',
        "&:hover, &:focus": {
          backgroundColor: "#E0E0E0"
        },
        textTransform: 'uppercase'
      }
}));

const ProblemCategory = ({selected, setSelected}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const classes = useStyles();

    const options = ['Fallen Tree(s)', 'Heavy Brush', 'Trail Structure Damage', 'Vandalism', 'Other'];
    
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleSelect = (option) => {
        setSelected(option);
    }

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    return (
    <>
        <Button aria-describedby={id} variant="contained" onClick={handleClick} className={classes.formControl}>
            {selected ? selected : 'Problem Category*'} <KeyboardArrowDownIcon />
        </Button>
        <Popover
            id={id}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
            }}
            transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
            }}
            classes={{paper: classes.popoverPaper}}
        >
        <div class={classes.container}>
            {options.map(option => <div className={classes.link} onClick={() => {handleSelect(option); handleClose();}}>{option}</div>)}
        </div>
        </Popover>
    </>
    )
};

export default ProblemCategory;